import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgAcneOneGlyph from './svgs/AcneOneGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var acneOneGlyph = (props => useIcon(SvgAcneOneGlyph, SvgAcneOneGlyph, props));

export { acneOneGlyph as default };
